import type { CustomPackConfig } from './customPack';

// The part of the custom pack adapters every pack page loads: an offer's rules. The rest of the lab's wire shapes live
// in customPackAdapters.ts, which only the lab imports, so a regular pack's bundle does not carry them.

export type Json = Record<string, unknown>;

export function isRecord(v: unknown): v is Json {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

/** A finite number from a JSON number or a numeric string; anything else is no number. */
export function toNumber(v: unknown): number | null {
  const n = typeof v === 'string' && v.trim() !== '' ? Number(v) : v;
  return typeof n === 'number' && Number.isFinite(n) ? n : null;
}

// Money and rules are read strictly: a field that is missing makes the whole
// value unusable, never a zero that would show as a free pack.
export function adaptCustomPackConfig(raw: unknown): CustomPackConfig | null {
  if (!isRecord(raw) || !isRecord(raw.limits)) return null;
  const rtpPpm = toNumber(raw.rtp_ppm);
  const minCards = toNumber(raw.limits.min_cards);
  const maxCards = toNumber(raw.limits.max_cards);
  const minChancePermille = toNumber(raw.limits.min_chance_permille);
  const maxChancePermille = toNumber(raw.limits.max_chance_permille);
  if (
    rtpPpm === null ||
    minCards === null ||
    maxCards === null ||
    minChancePermille === null ||
    maxChancePermille === null
  ) {
    return null;
  }
  return { rtpPpm, limits: { minCards, maxCards, minChancePermille, maxChancePermille } };
}
